function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 60,
  height: 60.444,
  fill: "none"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.217,
  y1: 0.215,
  x2: 0.844,
  y2: 0.861,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#34e4ea"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00ade6"
})), /*#__PURE__*/React.createElement("filter", {
  id: "ic_play_arrow_24px",
  x: 13,
  y: 6.003,
  width: 39.784,
  height: 54.441,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_7-2",
  "data-name": "Group 7",
  transform: "translate(-352.21 -1433.647)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_33",
  "data-name": "Ellipse 33",
  transform: "translate(352.21 1433.647)",
  fill: "none",
  stroke: "#2ad9e9",
  strokeWidth: 3
}, /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 28.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 352.21, 1433.65)",
  filter: "url(#ic_play_arrow_24px)"
}, /*#__PURE__*/React.createElement("path", {
  id: "ic_play_arrow_24px-2",
  "data-name": "ic_play_arrow_24px",
  d: "M8,5V41.441l21.784-18.22Z",
  transform: "translate(14 7)",
  fill: "url(#linear-gradient)"
}))));

var SvgPlay = function SvgPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60.444",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/play.a5d92013.svg";
export { ForwardRef as ReactComponent };